var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11459",
    d: "M1.875.013S4.98.003 9.064.003c2.227-.107 3.3 2.076 4.36 3.28h14.7A1.742 1.742 0 0130 4.92v17.172a1.892 1.892 0 01-1.875 1.906H1.875A1.892 1.892 0 010 22.092V1.921A1.892 1.892 0 011.875.013z",
    fill: "#61c8fa"
  })));
}
export default SvgFolderDropdown;